import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27dfd67d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.successful ? 'save-successful' : 'save-unsuccessful')
      }, [
        _createTextVNode(_toDisplayString(_ctx.successMsg) + " ", 1),
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "close",
              "data-dismiss": "alert",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
            }, _hoisted_2))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}